module.exports = __webpack_public_path__ + "images/Appointments_SS_499601047_251edbb.jpg";